"use client";

interface IGeneralModalProps {
  children?: React.ReactNode;
  title?: string;
  description?: string;
}

const GeneralModal = ({ children, title, description }: IGeneralModalProps) => {
  return (
    <div className="fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
      <div className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity" />
      <div className="inline-block bg-white rounded-sm px-4 py-5 text-left shadow-xl transform transition-all align-middle w-full max-w-[20rem]">
        <div className="flex items-center justify-center tracking-[0]">
          <div className="flex flex-col items-center justify-center mt-3">
            <p className="text-lg font-minion tracking-[0]">{title}</p>
            <div className="my-3 w-[10%] h-px bg-active" />

            <p className="text-sm text-secondary tracking-[0] text-center">
              {description}
            </p>
          </div>
        </div>
        <div className="flex flex-row gap-4 mt-6">{children}</div>
      </div>
    </div>
  );
};

export default GeneralModal;
